/**
 * Shared browser storage initialization used by index.jsx and StandaloneNavigation render.js.
 * Extracted for testability with passGate/failGate.
 */
import { Cookies } from '@confluence/cookies';
import { fg } from '@confluence/feature-gating';
import { initializeBrowserStorageControls } from '@confluence/browser-storage-controls/entry-points/initializeBrowserStorageControls.ts';

/**
 * Initialize browser storage (BSC or Cookies fallback) based on feature gates.
 * Must be called after Statsig is ready and before initializeStorageManager.
 *
 * @param {{ userId?: string, cloudId?: string }} context
 */
export async function initializeBootstrapStorage({ userId, cloudId }) {
	if (fg('confluence_browser_storage_controls')) {
		await initializeBrowserStorageControls(
			{ userId, cloudId },
			{
				platformAddFieldsToBscGlobalState: fg('platform_add_fields_to_bsc_global_state'),
				fedRampCookiesControlV2: fg('fedramp-cookies-control-v2'),
			},
		);
	} else {
		await Cookies.initialize(
			{ userId, cloudId },
			{
				platformAddFieldsToBscGlobalState: fg('platform_add_fields_to_bsc_global_state'),
				fedRampCookiesControlV2: fg('fedramp-cookies-control-v2'),
			},
		);
	}
}
